// Shared UI style constants for registar components
export const primary = '#155c2b';
export const accent = '#e67e22';

export const styles = {
  page: { padding: 40, minHeight: '100vh', background: '#f5f5f5' },
  title: { fontWeight: 700, fontSize: 28, marginBottom: 24, color: primary },
  input: { width: '100%', padding: 12, borderRadius: 6, border: '1px solid #ddd', fontSize: 18, background: '#fff' },
  tableWrapper: {
    width: '100%', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', borderCollapse: 'collapse', marginBottom: 24
  },
  theadRow: { background: '#f7f7f7' },
  th: { padding: 12, textAlign: 'left', border: '1px solid #e1e1e1' },
  td: { padding: 12 },
  trBorder: { borderBottom: '1px solid #f0f0f0' },
  btnPrimary: { background: primary, border: 'none', color: '#fff', padding: '8px 14px', borderRadius: 6, cursor: 'pointer', fontWeight: 700 },
  btnNeutral: { background: '#e0e0e0', color: '#222', border: 'none', padding: '10px 32px', borderRadius: 6, fontWeight: 700, cursor: 'pointer' },
  btnClose: { background: '#fff', color: accent, border: 'none', padding: '10px 32px', borderRadius: 6, fontWeight: 700, cursor: 'pointer' },
  iconButton: { background: 'none', border: 'none', fontSize: 28, cursor: 'pointer', color: primary },
  paginationActive: { background: primary, color: '#fff', borderRadius: 4 },
  modalBackdrop: { position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.35)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  modalBoxSmall: { background: '#fff', borderRadius: 10, padding: '40px 60px 32px 60px', minWidth: 500, maxWidth: 700, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.13)', position: 'relative' },
  modalBoxLarge: { background: '#fff', borderRadius: 10, padding: '0 0 32px 0', minWidth: 600, maxWidth: 1100, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.13)', position: 'relative' },
  modalHeading: { fontWeight: 700, fontSize: 28, textAlign: 'center', marginBottom: 32 },
  modalLink: { color: primary, textDecoration: 'underline', fontSize: 18, minWidth: 60, display: 'inline-block' },
  modalBtnPrimary: { background: primary, color: '#fff', border: 'none', borderRadius: 8, padding: '12px 38px', fontWeight: 700, fontSize: 18, cursor: 'pointer' },
  modalBtnClose: { background: accent, color: '#fff', border: 'none', borderRadius: 8, padding: '12px 38px', fontWeight: 700, fontSize: 18, cursor: 'pointer' }
};

export default styles;
